import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { compose } from 'redux';

import { open as openCheckboxesDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogActions';
import { open as openTreeViewDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/TreeViewDialog/TreeViewDialogActions';
import BarChartFilter from './BarChartFilter';
import {
  fetchFilterGroups as fetchFilterGroupsAction,
  toggleFilterGroup as toggleFilterGroupAction,
  fetchMoreFilterGroups as fetchMoreFilterGroupsAction,
  toggleFilterUserInput as toggleFilterUserInputAction,
  updateFilterUserInputValue as updateFilterUserInputValueAction,
  fetchSuppliersPreferencesGroups as fetchSuppliersPreferencesGroupsAction,
} from './BarChartFilterActions';
import { open as openFilterByValueConfirmDialog } from './FilterByValueConfirmDialog/FilterByValueConfirmDialogActions';
import { open as openLoginPromptDialog } from './LoginPromptDialog/LoginPromptDialogActions';
import { groupsSelectorFactory, commercialSuppliersFilterFactory } from './BarChartFilterSelectors';
import withBarChartFilterHandlers from './HOCs/withBarChartFilterHandlers';
import withBarChartFilterPropsMap from './HOCs/withBarChartFilterPropsMap';

export function BarChartFilterContainer(props) {
  const { filter, fetchFilterGroups, fetchSuppliersPreferencesGroups, isPreferredSuppliers } = props;

  useEffect(() => {
    if (filter.get('expanded') === true) {
      if (isPreferredSuppliers) {
        fetchSuppliersPreferencesGroups(filter);
      } else {
        fetchFilterGroups(filter);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return <BarChartFilter {...props} />;
}

BarChartFilterContainer.propTypes = {
  filter: PropTypes.instanceOf(Map),
  fetchFilterGroups: PropTypes.func,
  fetchSuppliersPreferencesGroups: PropTypes.func,
  isPreferredSuppliers: PropTypes.bool,
};

function mapStateToProps() {
  const { groups, isGroupsFetching } = groupsSelectorFactory();
  const { commercialSuppliersFilterGroups, isCommercialSuppliersFilterGroupsFetching } = commercialSuppliersFilterFactory();

  return (state, ownProps) => ({
    groups: groups(state, ownProps),
    isGroupsFetching: isGroupsFetching(state, ownProps),
    commercialSuppliersFilterGroups: commercialSuppliersFilterGroups(state),
    isCommercialSuppliersFilterGroupsFetching: isCommercialSuppliersFilterGroupsFetching(state),
  });
}

const mapDispatchToProps = {
  toggleFilterGroup: toggleFilterGroupAction,
  fetchFilterGroups: fetchFilterGroupsAction,
  fetchSuppliersPreferencesGroups: fetchSuppliersPreferencesGroupsAction,
  openTreeViewDialog,
  openCheckboxesDialog,
  fetchMoreFilterGroups: fetchMoreFilterGroupsAction,
  toggleFilterUserInput: toggleFilterUserInputAction,
  updateFilterUserInputValue: updateFilterUserInputValueAction,
  openFilterByValueConfirmDialog,
  openLoginPromptDialog,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBarChartFilterPropsMap,
  withBarChartFilterHandlers
)(BarChartFilterContainer);
